import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2mlu8ymvl5ns8">
      <MetaPixel data-id="element-1" data-mp="2mjpxnjvcxmhx" />
      <Hero data-id="element-2" data-mp="31aqeoda66opo" />
      <StatsAndProof data-id="element-3" data-mp="31b8ka0iq2fa9" />
      <PainPoints data-id="element-4" data-mp="31bs09botatln" />
      <ProductOffer data-id="element-5" data-mp="31c9u61o04vqe" />
      <Pricing showAnchor data-id="element-6" data-mp="31cjmvx0flgzs" />
      <ExtendedTestimonials data-id="element-7" data-mp="2wk9xqj754kyk" />
      <GuaranteeAndFaq data-id="element-8" data-mp="2wj8cxn0bok3n" />
      <CostSection data-id="element-9" data-mp="2wip734ny5m5z" />
      <Pricing data-id="element-10" data-mp="2wi5qbra193tj" />
      <FooterAndProofPopup data-id="element-11" data-mp="28u5ysp4wd9dw" />
    </main>;
}